
import { Options, Vue } from 'vue-class-component';
import EventBusService from "@/services/EventBusService";
import RegionService from "@/services/RegionService";
import { Region } from "@/data/region";
import { CourseProduct, Product } from "@/data/products";
import ProductCard from "@/components/ProductCard.vue";
import RegionCourses from "@/components/RegionCourses.vue";
// import PaymentCheckout from "@/components/payment/PaymentCheckout.vue";
import StepsCheckout from "@/components/checkout/StepsCheckout.vue";

@Options({
    props: {
        product: {
            type: Object,
            required: true,
        },
        regionName: {
            type: String,
            required: false,
        },
        /*showCoursesButton: {
            type: Boolean,
            required: false,
            default: false,
        },*/
        shown: {
            type: Boolean,
            required: true,
        }
    },
    components: {
        StepsCheckout,
        ProductCard,
        RegionCourses,
        // PaymentCheckout,
    },
    emits: [
        'close',
        'orderSuccess',
    ],
})
export default class ProductOrderPaymentModal extends Vue {
    //regionId: number|null = null
    region: Region|null = null
    regionName!: string|null
    //regionLocal: Region|null = null
    shown!: boolean
    //showCoursesButton = false

    product!: Product|CourseProduct

    regionStale = true

    loading = false

    checkoutSuccess = false
    checkoutSuccessMessage: string|string[]|null = null

    closeModal() {
        if( this.checkoutSuccess ) {
            EventBusService.$emit('user.credits:changed');
            if( this.product.type === 2 ) {
                // EventBusService.$emit('user.courses.enrollment:changed');
            }

            this.$emit('orderSuccess');
        }

        this.$emit('close');
        //this.cleanupPayPal();
        //this.$nextTick(this.cleanupPayPal);
    }

    loadRegion() {
        if( !this.product ) {
            return;
        }

        this.loading = true;
        return RegionService.getRegion(this.product.region_id).then(result => {
            this.region = result.data?.data;
        }).finally(() => this.loading = false);
    }

    handleSuccess(message?: string|string[]) {
        this.checkoutSuccess = true;
        this.checkoutSuccessMessage = message || null;
    }

    mounted() {
        /*this.$watch('region', (newRegion: Region|null) => {
            this.regionLocal = JSON.parse(JSON.stringify(newRegion));
        }, { immediate: true });

        this.$watch('regionId', (newRegionId: number|null) => {
            this.regionStale = true;
            / *if( newRegionId ) {
                this.$nextTick(this.loadRegion);
            }* /
        }, { immediate: true });*/

        this.$watch('product', () => {
            this.regionStale = true;
            /*if( newRegionId ) {
                this.$nextTick(this.loadRegion);
            }*/
        }, { immediate: true });
    }
}
